export default class CampaignModel {
    public id: string = null;
    public label: string = null;
}